module.exports = __webpack_public_path__ + "static/media/Jangl_shadow@2x.df1412fb.png";